import { render, staticRenderFns } from "./DeviceProfiles.vue?vue&type=template&id=34ce9584&"
import script from "./DeviceProfiles.vue?vue&type=script&lang=js&"
export * from "./DeviceProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports